<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import MixinList from '@/Libs/Mixins/List.js';

export default {
    mixins: [MixinList],
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            routeName: 'stuff-type',
        }
    },
    methods: {
        async _search() {
            var search = this.search;

            if (!search.order_by) {
                search.order_by = 'name';
                search.sort_by = 'asc';
            }

            return await this.$api.StuffType.all(search);
        },
        async _delete(params) {
            return await this.$api.StuffType.delete(params);
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="$t('stuff_type.title.list')" :pageTitle="$t('menu.sub_header.dashboard')" />

        <BRow class="g-4 align-items-center mb-3">
            <BCol sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                    <BButton type="button" variant="success" class="add-btn me-1" id="create-btn"
                        :to="{ name: 'stuff-type-create' }" v-if="$ac.hasAccess('stuff_type_create')">
                        <i class="ri-add-line align-bottom me-1"></i> {{ $t('basic.btn.add') }}
                    </BButton>
                </div>
            </BCol>
            <BCol sm>
                <div class="d-flex justify-content-sm-end">
                    <div class="search-box ms-2">
                        <b-form @submit="doSearch()">
                            <input type="text" class="form-control" v-model="search.keyword"
                                :placeholder="$t('filter.placeholder.keyword')" />
                            <i class="mdi mdi-magnify search-icon"></i>
                        </b-form>
                    </div>
                </div>
            </BCol>
        </BRow>

        <BRow>
            <BCol lg="12">
                <BCard no-body>
                    <BCardBody>
                        <div>
                            <div class="table-responsive table-card position-relative">
                                <loading :loading="$loading.get([routeName, 'list'].join('_'))" variant="dark"
                                    type="block">
                                    <table class="table align-middle table-hover table-nowrap mb-0">
                                        <thead class="table-light">
                                            <tr>
                                                <th style="width: 10px;">{{ $t('basic.label.line') }}</th>
                                                <th>{{ $t('stuff_type.label.shape') }}</th>
                                                <th>{{ $t('stuff_type.label.name') }}</th>
                                                <th>{{ $t('stuff_type.label.width') }}</th>
                                                <th>{{ $t('stuff_type.label.height') }}</th>
                                                <th>{{ $t('stuff_type.label.color') }}</th>
                                                <th>{{ $t('stuff_type.label.text_color') }}</th>
                                                <th style="width: 150px;">{{ $t('basic.label.action') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="cursor-pointer" v-for="(tr, index) in list" :key="index" @click="
                                                $ac.hasAccess('stuff_type_create') &&
                                                $router.push({ name: 'stuff-type-detail', params: { id: tr.id } })
                                                ">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ tr.shape }}</td>
                                                <td>
                                                    {{ tr.name }}
                                                    <BBadge variant="danger" v-if="tr.is_static == 1">{{
                                                        $t('stuff_type.label.static') }}</BBadge>
                                                </td>
                                                <td>{{ tr.width }}</td>
                                                <td>{{ tr.height }}</td>
                                                <td>{{ tr.color }}</td>
                                                <td>{{ tr.text_color }}</td>
                                                <td @click.stop>
                                                    <BDropdown variant="primary" no-caret size="md" strategy="fixed"
                                                        :toggle-class="{
                                                            'no-caret': $loading.get([routeName, 'delete', tr.id].join('_'))
                                                        }"
                                                        :disabled="$loading.get([routeName, 'delete', tr.id].join('_'))">
                                                        <template #button-content
                                                            class="btn btn-primary btn-md dropdown-toggle waves-effect waves-light shadow-none">
                                                            <loading
                                                                :loading="$loading.get([routeName, 'delete', tr.id].join('_'))"
                                                                variant="light" type="button">
                                                                {{ $t('basic.btn.action') }}
                                                            </loading>
                                                        </template>
                                                        <BDropdownItem @click.prevent="destroy(tr.id)" variant="danger"
                                                            v-if="$ac.hasAccess('stuff_type_delete')">
                                                            <i class="mdi mdi-delete-outline fs-16"></i> {{
                                                                $t('basic.btn.delete') }}
                                                        </BDropdownItem>
                                                    </BDropdown>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </loading>
                            </div>
                        </div>
                    </BCardBody>
                </BCard>
            </BCol>
        </BRow>
        <BRow class="mb-3">
            <BCol>
                <div>
                    <pagination v-bind:model="paginator" v-on:goto="goto" :disabled="$loading.get([routeName, 'list'].join('_'))"/>
                </div>
            </BCol>
        </BRow>
    </Layout>
</template>